import * as models from '../../store/models/store.model';
import * as fromStartData from '../../store/actions/';

const initialState: models.StartDataState = {
    CredencialRequest: null,
    FinanciadorRequest: null,
    PrestadorRequest: null,
    TransaccionRequest: null,
    AfiliadoRequest: null,
    PatientRequest: null
};

export function startDataReducer(
    state = initialState,
    action: fromStartData.startDataActions
): models.StartDataState {
    switch (action.type) {
        case fromStartData.SETCREDENCIALREQUEST:
            return {
                ...state,
                CredencialRequest: action.CredencialRequest,
            };

        case fromStartData.UNSETCREDENCIALREQUEST:
            return {
                ...state,
                CredencialRequest: null,
            };

        case fromStartData.SETCODIGODESEGURIDADREQUEST:
            if (state.CredencialRequest) {
                return {
                    ...state,
                    CredencialRequest: {
                        ...state.CredencialRequest,
                        VersionCredencial: action.CodigoDeSeguridadRequest,
                        csc: action.CodigoDeSeguridadRequest,
                    }
                };
            } else {
                return state;
            }

        case fromStartData.UNSETCODIGODESEGURIDADREQUEST:
            if (state.CredencialRequest) {
                return {
                    ...state,
                    CredencialRequest: {
                        ...state.CredencialRequest,
                        VersionCredencial: "",
                        csc: "",
                    }
                };
            } else {
                return state;
            }

        case fromStartData.SETFINANCIADORREQUEST:
            return {
                ...state,
                FinanciadorRequest: action.FinanciadorRequest,
            };

        case fromStartData.UNSETFINANCIADORREQUEST:
            return {
                ...state,
                FinanciadorRequest: null,
            };

        case fromStartData.SETPRESTADORREQUEST:
            return {
                ...state,
                PrestadorRequest: action.PrestadorRequest,
            };

        case fromStartData.UNSETPRESTADORREQUEST:
            return {
                ...state,
                PrestadorRequest: null,
            };

        case fromStartData.SETTRANSACCIONREQUEST:
            return {
                ...state,
                TransaccionRequest: action.TransaccionRequest,
            };

        case fromStartData.UNSETTRANSACCIONREQUEST:
            return {
                ...state,
                TransaccionRequest: null,
            };

        case fromStartData.SETAFILIADOREQUEST:
            return {
                ...state,
                AfiliadoRequest: action.AfiliadoRequest,
            };

        case fromStartData.UNSETAFILIADOREQUEST:
            return {
                ...state,
                AfiliadoRequest: null,
            };

        case fromStartData.SETPATIENTREQUEST:
            return {
                ...state,
                PatientRequest: action.PatientRequest,
            };

        case fromStartData.UNSETPATIENTREQUEST:
            return {
                ...state,
                PatientRequest: null,
            };

        case fromStartData.UNSETDATOS:
            return initialState;

        default:
            return state;
    }
}
